import { Field } from 'formik';
export function txtInput(errorsKey, touchedKey, label, name) {
  return <div className="space-y-1 px-4 sm:space-y-0 sm:grid sm:grid-cols-1 sm:gap-4 sm:px-6 sm:py-1">
    <label for={name} className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">{label}</label>
    <Field name={name} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
    {errorsKey && touchedKey ? (
      <div><span className="text-red-500 text-sm">{errorsKey}</span></div>
    ) : null}
  </div>;
}